<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.8 30.8761L33.4261 19.25L31.1 16.9739L21.95 26.1239L16.8718 21.0739L14.4739 23.4718L21.8 30.8761ZM23.9982 44.6848C19.1275 43.4652 15.1257 40.6635 11.9928 36.2798C8.85989 31.896 7.29346 27.0892 7.29346 21.8592V9.45651L24 3.21521L40.7348 9.45746V21.85C40.7348 27.0823 39.1631 31.8913 36.0196 36.2769C32.8761 40.6626 28.869 43.4652 23.9982 44.6848ZM24 40.6239C27.7391 39.263 30.7982 36.8667 33.1772 33.4348C35.5562 30.0029 36.7457 26.1441 36.7457 21.8583V12.2479L24 7.43261L11.2544 12.2615V21.8452C11.2544 26.1397 12.4439 30.0029 14.8229 33.4348C17.2018 36.8667 20.2609 39.263 24 40.6239Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
